import { post, get, put } from '../request'

export const createAct = (params) => post('api/acts', params)
export const updateAct = (id, params) => put(`api/acts/${id}`, params)
export const getActs = (filter, pagination) => get('api/acts', { filter, pagination })
export const collectItems = (act) => get(`api/act/collect-items/${act}`)
